import { GridColumns, GridValueGetterParams } from '@mui/x-data-grid-pro';
import { BloqueioResponse } from 'common/genericTypes';

export const getGravameGridColumns = (): GridColumns => [
  {
    field: 'gravameId',
    headerName: 'Código do Ativo',
    valueGetter: (params: GridValueGetterParams<BloqueioResponse>) =>
      params.row.instrumentoFinanceiro.codigo,
    minWidth: 200,
    flex: 1,
    resizable: true,
  },
  {
    field: 'quantidadeBloqueada',
    headerName: 'Quantidade Bloqueada',
    valueGetter: (params: GridValueGetterParams<BloqueioResponse>) => params.row.quantidade,
    minWidth: 200,
    flex: 1,
    resizable: true,
  },
  {
    field: 'dataBloqueio',
    headerName: 'Data do Bloqueio',
    valueGetter: (params: GridValueGetterParams<BloqueioResponse>) => {
      const dataCriacao = new Date(params.row.dataDeCriacao);
      return !isNaN(dataCriacao.getTime()) ? dataCriacao.toLocaleDateString() : 'Data inválida';
    },
    minWidth: 150,
    flex: 0.8,
    resizable: true,
  },
  {
    field: 'tipoBloqueio',
    headerName: 'Tipo do Bloqueio',
    valueGetter: (params: GridValueGetterParams<BloqueioResponse>) => params.row.tipo,
    minWidth: 200,
    flex: 1,
    resizable: true,
  },
];
